var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselectedSmileyDoNotKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#DBDBDB",
    cx: 512,
    cy: 512,
    r: 452.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -33.5462 532.8658)",
    fill: "#333333",
    cx: 352.7,
    cy: 289.7,
    rx: 90.1,
    ry: 58.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9974 -7.137749e-02 7.137749e-02 0.9974 -22.0393 51.1918)",
    fill: "#333333",
    cx: 705.3,
    cy: 334,
    rx: 58.8,
    ry: 90.1
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#333333",
    strokeWidth: 28.2902,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M706.2,595C564,514.2,356.9,555.5,275.9,700"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#DBDBDB",
    strokeWidth: 13.8,
    strokeMiterlimit: 10,
    cx: 512,
    cy: 512,
    r: 499.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedSmileyDoNotKnow);
export default __webpack_public_path__ + "static/media/unselected-smiley-do-not-know.d634b4ae5e2ac3076eb7ab6ba5a4de5a.svg";
export { ForwardRef as ReactComponent };